import type * as Types from "../../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentScheduleItemQueryVariables = Types.Exact<{
  uuid: Types.Scalars["String"]["input"];
}>;

export type GetAppointmentScheduleItemQuery = {
  __typename?: "Query";
  getAppointmentScheduleItem: {
    __typename?: "AppointmentSchedule";
    uuid: string;
    startTime: string;
    endTime: string;
    eventStatus: Types.ScheduleStatus;
    isLateCancel: boolean | null;
    unpaidReason: string | null;
    template: string | null;
    appointmentType: {
      __typename?: "AppointmentType";
      uuid: string;
      name: string;
      color: string;
    };
    appointmentCredit: {
      __typename?: "AppointmentCredit";
      uuid: string;
      expiresAt: string | null;
    } | null;
    staff: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
      primaryImage: string | null;
    } | null;
    user: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
      primaryImage: string | null;
    };
  };
};

export type GetUserCreditsQueryVariables = Types.Exact<{
  input: Types.GetUserAppointmentCreditsCountByTypeInput;
}>;

export type GetUserCreditsQuery = {
  __typename?: "Query";
  getUserAppointmentCreditsCountByType: {
    __typename?: "AppointmentCreditCount";
    count: number;
  };
};

export const GetAppointmentScheduleItemDocument = gql`
  query GetAppointmentScheduleItem($uuid: String!) {
    getAppointmentScheduleItem(uuid: $uuid) {
      uuid
      startTime
      endTime
      eventStatus
      isLateCancel
      unpaidReason
      template
      appointmentType {
        uuid
        name
        color
      }
      appointmentCredit {
        uuid
        expiresAt
      }
      staff {
        uuid
        firstName
        lastName
        primaryImage
      }
      user {
        uuid
        firstName
        lastName
        primaryImage
      }
    }
  }
`;

/**
 * __useGetAppointmentScheduleItemQuery__
 *
 * To run a query within a React component, call `useGetAppointmentScheduleItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentScheduleItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentScheduleItemQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetAppointmentScheduleItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppointmentScheduleItemQuery,
    GetAppointmentScheduleItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentScheduleItemQuery,
    GetAppointmentScheduleItemQueryVariables
  >(GetAppointmentScheduleItemDocument, options);
}
export function useGetAppointmentScheduleItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentScheduleItemQuery,
    GetAppointmentScheduleItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentScheduleItemQuery,
    GetAppointmentScheduleItemQueryVariables
  >(GetAppointmentScheduleItemDocument, options);
}
export type GetAppointmentScheduleItemQueryHookResult = ReturnType<
  typeof useGetAppointmentScheduleItemQuery
>;
export type GetAppointmentScheduleItemLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentScheduleItemLazyQuery
>;
export type GetAppointmentScheduleItemQueryResult = Apollo.QueryResult<
  GetAppointmentScheduleItemQuery,
  GetAppointmentScheduleItemQueryVariables
>;
export const GetUserCreditsDocument = gql`
  query GetUserCredits($input: GetUserAppointmentCreditsCountByTypeInput!) {
    getUserAppointmentCreditsCountByType(input: $input) {
      count
    }
  }
`;

/**
 * __useGetUserCreditsQuery__
 *
 * To run a query within a React component, call `useGetUserCreditsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCreditsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCreditsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserCreditsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserCreditsQuery,
    GetUserCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(
    GetUserCreditsDocument,
    options,
  );
}
export function useGetUserCreditsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserCreditsQuery,
    GetUserCreditsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserCreditsQuery, GetUserCreditsQueryVariables>(
    GetUserCreditsDocument,
    options,
  );
}
export type GetUserCreditsQueryHookResult = ReturnType<
  typeof useGetUserCreditsQuery
>;
export type GetUserCreditsLazyQueryHookResult = ReturnType<
  typeof useGetUserCreditsLazyQuery
>;
export type GetUserCreditsQueryResult = Apollo.QueryResult<
  GetUserCreditsQuery,
  GetUserCreditsQueryVariables
>;
